import MapPublicRoutes from 'js/vue-plugins/vue-router/routes/municipalities/map-public-routes' // OK Core
import PublicRoutes from 'js/vue-plugins/vue-router/routes/municipalities/public-routes' // OK Overwrites Core
import PrivateRoutes from 'js/vue-plugins/vue-router/routes/municipalities/private-routes' // OK Core

import modify_municipality_news_path from './modify-municipality-news-path'

import Municipality  from 'js/pages/municipality/index.js'

modify_municipality_news_path(PublicRoutes)

export default {
  path: '/:country/:municipality',
  name: 'municipality',
  component: Municipality,
  children: [
    ...normalizeRoutes(MapPublicRoutes),
    ...normalizeRoutes(PublicRoutes),
    ...normalizeRoutes(PrivateRoutes)
  ]
}